// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_bj-2";
export var aiChatCartContainerExit = "_bj-4";
export var aiChatContainerLarge = "_bj-0";
export var aiChatContainerSmall = "_bj-1";
export var aiChatIcon = "_bj-6";
export var slideInFromRight = "_bj-3";
export var slideOutToRight = "_bj-5";